import React, { useState, forwardRef, useImperativeHandle } from "react";
import {
  Dialog,
  DialogContent,
  InputLabel,
  Stack,
  Typography,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CodeInput from "react-code-input";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "400px",
    borderRadius: "12px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const OTPModal = forwardRef(
  ({ handleClickResend, handleSubmitVendor }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [otp, setOtp] = useState("");

    useImperativeHandle(ref, () => ({
      open(params) {
        paramsData = params;
        setIsOpen(true);
      },
      close() {
        setIsOpen(false);
        setOtp("");
      },
    }));

    const handleChange = (value) => {
      setOtp(value);
    };

    const handleVerifyOtp = () => {
      let randomNumber = Math.floor(10000000 + Math.random() * 90000000);
      let params = {
        name: paramsData?.name,
        email: paramsData?.email,
        phoneNumber: paramsData?.phone,
        referalCode: "",
        password: paramsData?.password,
        fcm: "",
        role: "vendor",
        otp: otp,
        vendorShare: paramsData?.vendorShare,
        bbShare: paramsData?.bbShare,
        customerShare: paramsData?.customerShare,
      };
      handleSubmitVendor(params);
    };

    return (
      <BootstrapDialog onClose={() => setIsOpen(false)} open={isOpen}>
        <DialogContent>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={600}
            textAlign={"center"}
            color={"primary.light"}
          >
            Enter OTP
          </Typography>

          <Stack direction="column" spacing={2} alignItems="center" mt={2}>
            <InputLabel>Enter 4-digit OTP</InputLabel>
            <CodeInput
              type="number"
              fields={4}
              value={otp}
              onChange={handleChange}
              inputStyle={{
                width: "40px",
                height: "40px",
                textAlign: "center",
                fontSize: "20px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                margin: "5px",
              }}
            />
          </Stack>

          <Stack direction="row" justifyContent="center" gap={2} mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleVerifyOtp}
            >
              Submit
            </Button>
            <Button variant="outlined" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </Stack>
          <Stack
            direction={"row"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 3,
            }}
          >
            <Typography
              fontSize={"0.678rem"}
              fontWeight={600}
              textAlign={"center"}
            >
              Did'nt recive OTP?
            </Typography>
            <Typography
              onClick={() => handleClickResend(paramsData)}
              fontSize={"0.678rem"}
              fontWeight={600}
              textAlign={"center"}
              color={"primary"}
              ml={0.5}
              sx={{
                cursor: "pointer",
              }}
            >
              Resend
            </Typography>
          </Stack>
        </DialogContent>
      </BootstrapDialog>
    );
  }
);

export default OTPModal;
